import { Action, ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import {
  VodPageAction,
  VodPageMutation,
  VodPageState
} from "@/components/VoD/types";
import apiStorageInterface from "@/services/apiStorageInterface";
import { VoDGenre } from "@/services/apiService/api.types";
import { OverlaySection } from "@/components/overlay/types";

const updateMoviesByGenre = async (
  context: ActionContext<VodPageState, RootState>
): Promise<void> => {
  const movByGenre = await apiStorageInterface.fetchMoviesByGenre();
  const favMovies = await apiStorageInterface.fetchFavoriteMovies();

  if (favMovies.length > 0) {
    const favGenre: VoDGenre = {
      id: 0,
      order: 0,
      name: "Favorites",
      latestMovies: favMovies
    };
    movByGenre.unshift(favGenre);
  }
  context.commit(VodPageMutation.setMoviesByGenre, movByGenre);
};

const updateTvShowsByGenre = async (
  context: ActionContext<VodPageState, RootState>
): Promise<void> => {
  const tvShowByGenre = await apiStorageInterface.fetchTvShowsByGenre();
  const favTvShows = await apiStorageInterface.fetchFavoriteTvShows();

  if (favTvShows.length > 0) {
    const favGenre: VoDGenre = {
      id: 0,
      order: 0,
      name: "Favorites",
      latestTvShows: favTvShows
    };
    tvShowByGenre.unshift(favGenre);
  }

  context.commit(VodPageMutation.setTvShowsByGenre, tvShowByGenre);
};

const updatePlayerOpenStatus = (
  context: ActionContext<VodPageState, RootState>,
  overlayStatus: OverlaySection
): void => {
  if (!overlayStatus) {
    context.commit(VodPageMutation.setClosePlayer, false);
    return;
  }
  context.commit(VodPageMutation.setClosePlayer, true);
};

export const actions: ActionTree<VodPageState, RootState> &
  Record<VodPageAction, Action<VodPageState, RootState>> = {
  [VodPageAction.UpdateMoviesByGenre]: updateMoviesByGenre,
  [VodPageAction.UpdateTvShowsByGenre]: updateTvShowsByGenre,
  [VodPageAction.UpdateClosePlayer]: updatePlayerOpenStatus
};
